import { Alert } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { Z_INDEX } from '@/constants';
import { responsive } from '@/utils';

/**
 * Shown while a widget's request is being retried because the API answered HTTP 429. It renders
 * above the loading overlay, so it explains both a spinner that is taking unusually long and a
 * widget that has drawn the data it has while the rest is still being retried.
 */
export const HighTrafficAlert = ({ zIndex = Z_INDEX.overlay.error }: { zIndex?: number }) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity='caution'
      text={t('dataDelayedHighTraffic')}
      style={{
        borderRadius: `${responsive.radius.small}`,
        bottom: 0,
        height: `${responsive.spacing['5xlarge']}`,
        marginBottom: `${responsive.spacing.medium}`,
        marginLeft: `${responsive.spacing.xlarge}`,
        minHeight: `${responsive.spacing['5xlarge']}`,
        position: 'absolute',
        zIndex,
      }}
    />
  );
};
